<template>
  <div>
    <!-- Zerésima: relatório de urna vazia, registrado no momento do início da
         eleição (mesma transação do lacre). Reimpressões mostram sempre os
         números do início, lidos do registro da trilha de auditoria. -->
    <div
      class="modal fade right"
      data-backdrop="static"
      id="modalzeresima"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zerésima da Eleição</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Loading v-if="carregando" />
            <div v-else-if="erro" class="alert alert-warning">{{ erro }}</div>
            <div v-else id="zeresima-conteudo">
              <div class="text-center mb-3">
                <img
                  :src="logo"
                  class="rounded mx-auto d-block no-print"
                  style="width: 130px; margin-top: 5px"
                />
                <h4 class="txt-titulo mt-2 mb-0"><strong>ZERÉSIMA</strong></h4>
                <div>Relatório de urna vazia no início da eleição</div>
              </div>
              <table class="table table-bordered tabela-zeresima">
                <tbody>
                  <tr>
                    <td class="rotulo">Eleição</td>
                    <td>
                      <strong>{{ eleicaoZ.strdescricao }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="rotulo">Período de votação</td>
                    <td>
                      {{ dados.dtainicial | dateFull_br }} a
                      {{ dados.dtafinal | dateFull_br }}
                    </td>
                  </tr>
                  <tr>
                    <td class="rotulo">Início e lacre da urna</td>
                    <td>
                      {{ dataHora(z.emitida_em) }} — por {{ z.emitida_por }}
                    </td>
                  </tr>
                  <tr>
                    <td class="rotulo">Impressão digital da urna</td>
                    <td class="mono">
                      <strong>{{ dados.impressao_digital }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="rotulo">Eleitores aptos</td>
                    <td>{{ dados.eleitores_aptos }}</td>
                  </tr>
                  <tr>
                    <td class="rotulo">Comparecimentos registrados</td>
                    <td>
                      <strong>{{ dados.comparecimentos }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="rotulo">Cédulas na urna</td>
                    <td>
                      <strong>{{ dados.cedulas }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="rotulo">Votos apurados</td>
                    <td>
                      <strong>{{ dados.votos_apurados }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-bordered tabela-zeresima">
                <thead>
                  <tr>
                    <th style="width: 90px">Número</th>
                    <th>Candidato</th>
                    <th style="width: 90px" class="text-center">Votos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(c, i) in dados.candidatos || []" :key="i">
                    <td>{{ c.numero }}</td>
                    <td>{{ c.nome }}</td>
                    <td class="text-center">
                      <strong>{{ c.votos }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>

              <p class="declaracao">
                Declaramos que, no momento do início da eleição, o sistema
                verificou que
                <strong
                  >não havia nenhum comparecimento, cédula ou voto
                  registrado</strong
                >
                para esta eleição, e que a votação foi aberta com a urna vazia.
              </p>
              <p class="autenticidade">
                Registro de auditoria nº <strong>{{ z.registro }}</strong> —
                hash <span class="mono">{{ z.hash }}</span
                >.<br />
                A autenticidade pode ser conferida no eVoto em
                <em>Auditoria → Verificar integridade</em>.
              </p>

              <table class="assinaturas">
                <tr>
                  <td>
                    <div class="linha"></div>
                    Presidente da Comissão
                  </td>
                  <td>
                    <div class="linha"></div>
                    Representante Diretoria de Tecnologia
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="linha"></div>
                    Membro Titular da Comissão
                  </td>
                  <td>
                    <div class="linha"></div>
                    Membro Titular da Comissão
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-sm-12 col-md-12 col-lg-12 text-center">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="gerando || carregando || !!erro"
                @click="gerarPdf"
              >
                <span v-if="!gerando"
                  ><i class="fa fa-print mr-1 pr-1"></i> Imprimir (PDF)</span
                >
                <Loading v-else title="gerando" :icon="false" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "./../../mixins";
import Loading from "../misc/Loading";
import FileSaver from "file-saver";

const CSS_PDF = `
<style>
  * { font-family: sans-serif; font-size: 10pt !important; }
  h4, h4 strong { font-size: 15pt !important; }
  .no-print { display: none !important; }
  .text-center { text-align: center; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 14px; }
  .tabela-zeresima td, .tabela-zeresima th { border: 1px solid #999; padding: 4px 6px; text-align: left; }
  .tabela-zeresima th { background: #eee; }
  .rotulo { width: 42%; color: #333; }
  .mono { font-family: monospace !important; word-break: break-all; }
  .declaracao { margin-top: 10px; text-align: justify; }
  .autenticidade { font-size: 8pt !important; color: #444; }
  .autenticidade * { font-size: 8pt !important; }
  .assinaturas td { width: 50%; padding: 40px 20px 0 20px; text-align: center; vertical-align: bottom; }
  .assinaturas .linha { border-top: 1px solid #000; margin-bottom: 4px; }
  tr { page-break-inside: avoid; }
</style>`;

export default {
  props: ["eleicao"],
  mixins: [Mixin],
  components: { Loading },
  data() {
    return { carregando: true, gerando: false, erro: "", z: {}, eleicaoZ: {} };
  },
  computed: {
    dados() {
      return this.z.dados || {};
    },
    logo() {
      return process.env.VUE_APP_IMG_LOGO;
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      this.erro = "";
      await axios.get(`/eleicoes/zeresima/${this.eleicao.id}`).then(
        (res) => {
          this.z = res.data.zeresima || {};
          this.eleicaoZ = res.data.eleicao || {};
        },
        (e) => {
          this.erro =
            (e.response && e.response.data && e.response.data.mensagem) ||
            "Não foi possível obter a zerésima.";
        },
      );
      this.carregando = false;
    },
    dataHora(d) {
      try {
        return new Date(d).toLocaleString("pt-BR", {
          timeZone: "America/Sao_Paulo",
        });
      } catch (e) {
        return d;
      }
    },
    gerarPdf() {
      this.gerando = true;
      const dados = {
        html: CSS_PDF + $("#zeresima-conteudo").html(),
        pdf: {
          displayHeaderFooter: "true",
          headerTemplate:
            '<img style="display: block; margin-left: 250px;" src="' +
            process.env.VUE_APP_IMG_B64_IMPRESSAO +
            '" width="100" height="70">',
          footerTemplate:
            "<div style='font-size: 6px !important; border-top: 1px solid #000; width: 100%; display:inline-block;'><div style='float: left; margin-left:10px; margin-top:5px;'>E-Voto | Zerésima — registro de auditoria nº " +
            this.z.registro +
            " | " +
            process.env.VUE_APP_RODAPE_IMPRESSAO +
            "</div><div style='float: right; margin-right:10px; margin-top:5px;'><div class='pageNumber' style='display:inline-block;'></div>/<div class='totalPages' style='display:inline-block;'></div></div></div>",
          format: "A4",
          margin: { left: "2cm", top: "4cm", right: "2cm", bottom: "2cm" },
        },
      };
      axios
        .post(process.env.VUE_APP_URL_PDF, dados, {
          responseType: "arraybuffer",
          headers: { Accept: "application/pdf" },
        })
        .then(
          (res) => {
            FileSaver.saveAs(
              new Blob([res.data], { type: "application/pdf" }),
              `zeresima-eleicao-${this.eleicao.id}.pdf`,
            );
          },
          () => toastr.error("Falha ao gerar o PDF da zerésima"),
        )
        .then(() => {
          this.gerando = false;
        });
    },
  },
};
</script>

<style scoped>
.tabela-zeresima {
  font-size: 10pt;
}
.tabela-zeresima .rotulo {
  width: 42%;
  color: #555;
}
.mono {
  font-family: monospace;
  word-break: break-all;
}
.declaracao {
  text-align: justify;
}
.autenticidade {
  font-size: 9pt;
  color: #555;
}
.assinaturas {
  width: 100%;
  margin-top: 10px;
}
.assinaturas td {
  width: 50%;
  padding: 36px 20px 0 20px;
  text-align: center;
  font-size: 10pt;
}
.assinaturas .linha {
  border-top: 1px solid #000;
  margin-bottom: 4px;
}
</style>
